import { Link } from "react-router-dom";
import cn from 'classnames';
import { useState } from "react";

type IDropdown = {
  text: string;
  link?: string;
  items?: {
    text: string,
    link: string
  }[];
}

const Dropdown = ({text, link, items}: IDropdown) => {
  const [show, setShow] = useState(false);

  const handleOpen = () => {
    setShow(s => !s);
  }

  return <div onMouseEnter={handleOpen} onMouseLeave={handleOpen} className="relative [--gpu-acceleration:false] inline-flex">
    {!link && (
      <div className="toggle" aria-haspopup="menu" aria-expanded={show}>
        {text}
      </div>
    )}
    {link && (
      <Link to={link} className="toggle" aria-haspopup="menu" aria-expanded={show}>
        {text}
      </Link>
    )}
    <div
      className={cn(
        'scale-95',
        'opacity-0',
        'z-10',
        'ease-in-out',
        'transition-[transform,opacity]',
        'duration-200',
        'bg-white',
        'shadow-md',
        'rounded-lg',
        'absolute',
        'left-1/2',
        '-translate-x-1/2',
        'top-8',
        'min-w-full',
        {
          'scale-100': show,
          'opacity-100': show,
          'pointer-events-none': !show
        }
      )}
      role="menu"
      aria-orientation="vertical"
      hidden={!show}
    >
      <div className="p-1 space-y-0.5">
        {items && items.map(item => (
          <Link
            key={item.text.replace(' ', '')}
            role="menuitem"
            className="flex items-center transition-[background-color] ease-in-out duration-500 gap-x-3.5 py-2 px-3 rounded-lg text-black focus:outline-none text-sm hover:bg-gray-100 focus:bg-gray-100"
            to={item.link}
          >
            {item.text}
          </Link>
        ))}
      </div>
    </div>
  </div>
}

export default Dropdown;